function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from 'modules/Visit/messages';
import noteShape from 'shapes/noteShape';
var _React_PureComponent;
class ReplyBtn extends (_React_PureComponent = React.PureComponent) {
    onReply(evt, note) {
        evt.preventDefault();
        this.props.onReply(note);
    }
    render() {
        const { note } = this.props;
        return /*#__PURE__*/ _jsx("a", {
            href: "",
            className: "d-inline-block text--bold text--base",
            onClick: (evt)=>this.onReply(evt, note),
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.reply))
        });
    }
}
_define_property(ReplyBtn, "propTypes", {
    note: noteShape,
    onReply: PropTypes.func
});
export default ReplyBtn;
